// Traduções do editor de cargas da Programação, no portal e no ajuste da equipe.
// Coletadas por glob em core/i18n/messages.ts. Sem parêntese nem travessão no texto.
export default {
  pt: {
    'programacao.visual.semConjunto': 'Sem conjunto escalado',
    'programacao.visual.outraTransportadora': 'Outra transportadora',
    'programacao.visual.semCavalo': 'Sem cavalo',
    'programacao.visual.nCargas': 'Cargas: {{n}}',
    'programacao.visual.nenhuma': 'Nenhuma carga',
    'programacao.visual.sai': 'Sai',
    'programacao.visual.entra': 'Nova',
    'programacao.visual.antes': 'Antes',
    'programacao.visual.agora': 'Agora',
    'programacao.editor.lista': 'Cargas da programação',
    'programacao.editor.carga': 'Carga {{n}}',
    'programacao.editor.vazia': 'Nenhuma carga. Acrescente uma carga ou envie assim para zerar o dia.',
    'programacao.editor.nova': 'Nova',
    'programacao.editor.era': 'Era {{h}}',
    'programacao.editor.daEquipe': 'Incluída pela equipe',
    'programacao.editor.tirar': 'Tirar a carga {{n}}',
    'programacao.editor.adicionar': 'Carga',
    'programacao.editor.acrescentar': 'Acrescentar carga',
    'programacao.editor.limite': 'Até {{n}} cargas por programação',
    'programacao.editor.saem': 'Saem: {{n}}',
    'programacao.editor.devolver': 'Devolver',
    'programacao.editor.devolverHorario': 'Devolver a carga das {{h}}',
    'programacao.editor.aPartirTitulo': 'A partir da carga',
    'programacao.editor.aPartirTexto': 'Da carga escolhida em diante, os horários recomeçam no primeiro horário, no intervalo informado.',
    'programacao.editor.aPartirDa': 'A partir da',
    'programacao.editor.primeiroHorario': 'Primeiro horário',
    'programacao.editor.intervalo': 'Intervalo',
    'programacao.editor.min': 'min',
    'programacao.editor.aplicar': 'Aplicar',
  },
  en: {
    'programacao.visual.semConjunto': 'No set scheduled',
    'programacao.visual.outraTransportadora': 'Other carrier',
    'programacao.visual.semCavalo': 'No truck',
    'programacao.visual.nCargas': 'Loads: {{n}}',
    'programacao.visual.nenhuma': 'No loads',
    'programacao.visual.sai': 'Leaves',
    'programacao.visual.entra': 'New',
    'programacao.visual.antes': 'Before',
    'programacao.visual.agora': 'Now',
    'programacao.editor.lista': 'Schedule loads',
    'programacao.editor.carga': 'Load {{n}}',
    'programacao.editor.vazia': 'No loads. Add a load or send it like this to clear the day.',
    'programacao.editor.nova': 'New',
    'programacao.editor.era': 'Was {{h}}',
    'programacao.editor.daEquipe': 'Added by the team',
    'programacao.editor.tirar': 'Remove load {{n}}',
    'programacao.editor.adicionar': 'Load',
    'programacao.editor.acrescentar': 'Add load',
    'programacao.editor.limite': 'Up to {{n}} loads per schedule',
    'programacao.editor.saem': 'Leaving: {{n}}',
    'programacao.editor.devolver': 'Bring back',
    'programacao.editor.devolverHorario': 'Bring back the {{h}} load',
    'programacao.editor.aPartirTitulo': 'From a load',
    'programacao.editor.aPartirTexto': 'From the chosen load onward, the times restart at the first time, at the given interval.',
    'programacao.editor.aPartirDa': 'From',
    'programacao.editor.primeiroHorario': 'First time',
    'programacao.editor.intervalo': 'Interval',
    'programacao.editor.min': 'min',
    'programacao.editor.aplicar': 'Apply',
  },
  es: {
    'programacao.visual.semConjunto': 'Sin conjunto asignado',
    'programacao.visual.outraTransportadora': 'Otra transportadora',
    'programacao.visual.semCavalo': 'Sin tractor',
    'programacao.visual.nCargas': 'Cargas: {{n}}',
    'programacao.visual.nenhuma': 'Ninguna carga',
    'programacao.visual.sai': 'Sale',
    'programacao.visual.entra': 'Nueva',
    'programacao.visual.antes': 'Antes',
    'programacao.visual.agora': 'Ahora',
    'programacao.editor.lista': 'Cargas de la programación',
    'programacao.editor.carga': 'Carga {{n}}',
    'programacao.editor.vazia': 'Ninguna carga. Agregue una carga o envíe así para dejar el día en cero.',
    'programacao.editor.nova': 'Nueva',
    'programacao.editor.era': 'Era {{h}}',
    'programacao.editor.daEquipe': 'Incluida por el equipo',
    'programacao.editor.tirar': 'Quitar la carga {{n}}',
    'programacao.editor.adicionar': 'Carga',
    'programacao.editor.acrescentar': 'Agregar carga',
    'programacao.editor.limite': 'Hasta {{n}} cargas por programación',
    'programacao.editor.saem': 'Salen: {{n}}',
    'programacao.editor.devolver': 'Devolver',
    'programacao.editor.devolverHorario': 'Devolver la carga de las {{h}}',
    'programacao.editor.aPartirTitulo': 'A partir de la carga',
    'programacao.editor.aPartirTexto': 'Desde la carga elegida en adelante, los horarios recomienzan en el primer horario, con el intervalo informado.',
    'programacao.editor.aPartirDa': 'A partir de la',
    'programacao.editor.primeiroHorario': 'Primer horario',
    'programacao.editor.intervalo': 'Intervalo',
    'programacao.editor.min': 'min',
    'programacao.editor.aplicar': 'Aplicar',
  },
}
